import { createErrorMatcher } from '@shared/lib/http-error';

const isUserNotConfirmedError = createErrorMatcher('UserNotConfirmedException');
const isUserAlreadyExistError = createErrorMatcher('UsernameExistsException');

export { isUserAlreadyExistError, isUserNotConfirmedError };
